var CONFUSEDCORE = CONFUSEDCORE || {};
CONFUSEDCORE.HELPERS = CONFUSEDCORE.HELPERS || {};

/*
@desc: Redirect Helper
 */ 
CONFUSEDCORE.HELPERS.RedirectHelper = (function(){

	return {
		redirect: function(url){
			window.location.href = url;
		}
	};

})();